import * as req from 'api/actions';
import * as c from './constant';

export const getOrdinanceRevisionEffectivity = (payload, callback) =>
req.list(
  c.GET_ORDINANCE_REVISION_EFFECTIVITY,
  `/api/v1/bpls/administrator/common/ordinance_revisions`,
  payload,
  callback
);

// dummy
export const dummy = (payload, callback) =>
req.list(
  c.GET_ORDINANCE_REVISION_EFFECTIVITY,
  `/api/v1/bpls/administrator/common/ordinance_revisions`,
  payload,
  callback
);

export const getReports = (payload, callback) =>
  req.create(
    c.GET_REPORTS,
    '/api/v1/administrators/export_audits',
    payload,
    callback
  );
  
export const getReportList = (payload, callback) => 
req.list(
  c.GET_REPORT_LIST,
  '/api/v1/administrators/general/audits',
  payload,
  callback
);

export const getTransactionalReportList = (payload, callback) => 
  req.list(
    c.GET_TRANSACTIONAL_REPORT_LIST,
    '/api/v1/administrators/transactional/audits',
    payload,
    callback
  );

export const generateAuditLogReports = (payload = {}, callback) =>
  req.list(
    c.GENERATE_AUDIT_LOG,
    '/api/v1/administrators/general/export_audits',
    payload,
    callback
  );

export const generateTransactionalAuditLogReports = (payload = {}, callback) =>
  req.list(
    c.GENERATE_TRANSACTIONAL_AUDIT_LOG,
    '/api/v1/administrators/transactional/export_audits',
    payload,
    callback
  );  

export const getExportList = (payload, callback) => 
  req.list(
    c.GET_EXPORT_LIST,
    '/api/v1/administrators/transactional/export_audits',
    payload,
    callback
  );

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    '/api/v1/bpls/administrator/reports/pre_registrations',
    payload,
    callback
  );


  // {host}}/api/v1/administrators/transaction

  // {{host}}/api/v1/administrators/transactional/export_audits?q=The document was received&module=MARRIAGE_CERTIFICATE_AUDIT&date_from=2023-08-01&date_to=2024-09-15


//   {{host}}/api/v1/administrators/general/audits?event=Log-in
// {{host}}/api/v1/administrators/general/export_audits?event=Log-in


// curl --location 'localhost:9091/api/v1/administrators